import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import routeList from '../../routes/routeList';
import icon_magnifying from '../../images/icons/icon_magnifying.svg';

const SearchBox = ({ history }) => {
  const [searchField, setSearchField] = useState('');
  const handleInputChange = e => {
    setSearchField(e.target.value);
  };

  const searchSubmit = e => {
    e.preventDefault();
    if (searchField !== '') {
      history.push(`${routeList.search}/${searchField}`);
    }
  };

  return (
    <section className="section-header">
      <div className="section-search text-center">
        <form onSubmit={searchSubmit}>
          <label htmlFor="header-search" className="hidden-label">
            Wpisz tytuł autora, lub książki
          </label>
          <input
            type="text"
            value={searchField}
            id="header-search"
            onChange={handleInputChange}
            placeholder="Wpisz tytuł lub autora książki"
          />
          <button className="btn-primary" type="submit">
            <img src={icon_magnifying} width="18" height="18" alt="Ikona lupy" />
            <span className="i-text ml-2">Szukaj</span>
          </button>
        </form>
      </div>
    </section>
  );
};

export default withRouter(SearchBox);
